<script setup lang="ts">
	import { cn } from '~/utils/functions'

	const props = withDefaults(
		defineProps<{
			disableBtn?: boolean
			btnRelative?: boolean
			btnClass?: string
			isTermsOpen?: boolean
			useFixedHeader?: boolean
			fixedClass?: ClassContext
			ui?: {
				back?: string
			}
		}>(),
		{
			disableBtn: true
		}
	)
	const emit = defineEmits<{
		(arg: 'back'): void
		(arg: 'update:isTermsOpen', param: boolean): void
	}>()
</script>

<template>
	<section class="relative mx-auto">
		<dashboard-back-button
			v-if="!disableBtn"
			:class="cn({ 'lg:fixed': !btnRelative }, btnClass, ui?.back)"
			@click="emit('back')"
		>
			<lazy-tools-icon
				icon="arrow-long-left"
				dir="arrows"
				class="animate-x mr-5"
				path-class="group-hover:fill-white transition-color ease-linear"
			/>
			<span
				class="transition-color text-[12px] font-[600] leading-[20px] text-gray-600 ease-in group-hover:text-white"
			>
				Go Back
			</span>
		</dashboard-back-button>
		<div>
			<div class="w-full" :class="{ 'fixed-header': useFixedHeader }">
				<slot name="header" />
			</div>

			<div
				class="relative"
				:class="cn({ 'w-full py-5 md:mt-0 md:py-20': useFixedHeader }, useFixedHeader ? fixedClass : '')"
			>
				<slot />
			</div>

			<dialogs-terms-and-condition
				:show="isTermsOpen as boolean"
				custom-class="items-center"
				@change="emit('update:isTermsOpen', false)"
			/>
		</div>
	</section>
</template>

<style scoped>
	.fixed-header {
		@apply left-0 top-0 z-20 flex flex-col justify-end bg-gray-50 md:fixed md:min-h-[155px] md:pt-5;
	}
</style>
